import React from 'react'
import styled from 'styled-components'

const Line = styled.div` 
    float:right;
    padding-right:30px;
`

const FooterComponent = () => {

    return (
        <footer className = "footer">
            <Line>
                &copy; <a target="_blank" href="https://general-solutions.at">General Solutions Steiner GmbH</a>
            </Line>
        </footer>
    )
}

export default FooterComponent